import { NE_PRINT_LABEL_SOURCE } from 'domains/NuvemEnvioCommons/constants';
import { ORDERS_SECTION_ROUTES } from 'domains/Orders/Orders/ordersSectionRoutes';

const getReturnPrintLabelUrl = (source: string, orderId: string) => {
  if (source === NE_PRINT_LABEL_SOURCE.ORDER_DETAILS && orderId) {
    return ORDERS_SECTION_ROUTES.orderDetails.replace(':id', orderId);
  }
  return ORDERS_SECTION_ROUTES.orderList;
};

export default getReturnPrintLabelUrl;
